define('v3/Common/Components/PupilDropdown/Services/pupilService',[
	'jquery',
	'lodash',
	'v3/Common/Components/PupilDropdown/Services/pupilBackend',
	'v3/Common/Models/enums',
	'v3/FromV2/localStorageV3Service',
	'v3/Common/Helpers/Sort/Sort.Helper'
], function ($, _, pupilBackend, enums, localStorageV3Service, sortableHelper) {
	return {
		getAllInSubjectGroupsInCurrentClass: _.memoize(function () {
			return $.when(pupilBackend.getAllInSubjectGroupsInCurrentClass())
				.then(function (pupils) {
					var pupilModels = _.map(pupils, function (pupilArrayOfNames, pupilId) {
						return {
							pupilId: +pupilId,
							longName: pupilArrayOfNames[enums.pupilBackendNames.longName],
							pupilNameForSorting: sortableHelper.prototype.settingsSortingKey() === 'lastNameForSorting'
								? pupilArrayOfNames.slice(0, 3).reverse().join(' ')
								: pupilArrayOfNames.slice(0, 3).join(' ')
						};
					});
					return _.sortBy(pupilModels, function (o) { return o.pupilNameForSorting.trim().toLowerCase(); });
				}, function (xhr) {
					if (xhr.status === 404) {
						return null;
					}

					return new Error('Internal server error.');
				});
		}),

		savePupilId: function (pupilId) {
			localStorageV3Service.setPupilFilterStateLocalStorage({ pupilIdFilter: pupilId });
		},

		getPupilId: function () {
			var pupilFilterState = localStorageV3Service.getPupilFilterStateLocalStorage();
			if (pupilFilterState) {
				return pupilFilterState.pupilIdFilter;
			}
			return null;
		}
	};
});
